module.exports = __webpack_public_path__ + "static/media/audioCopy.caa70bbe.svg";